import {
    Box,
    Container,
    Divider,
    Grid,
    Stack,
    Typography,
} from "@mui/material";
import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import SlidingBanner from "./Banner";
import Footer from "./footer";
 
  

export const Supply = () => {
  const banners = [
    {
      id: 1,
      img: "../img/ServicePageSlide/SLIDE1.jpg",
      alt: "Slide 1",
    },
    {
      id: 2,
      img: "../img/ServicePageSlide/SLIDE2.jpg",
      alt: "Slide 2",
    },
    {
      id: 3,
      img: "../img/ServicePageSlide/SLIDE3.jpg",
      alt: "Slide 3",
    },
    {
      id: 3,
      img: "../img/ServicePageSlide/SLIDE4.jpg",
      alt: "Slide 3",
    },
  ];
    return(
        <div style={{backgroundColor:"#03203f"}}>
            <SlidingBanner banners={banners}/>
            <Box sx={{mt:0, bgcolor:"#03203f"}}>
                <Container>
                    {/* Erection Work */}
                    <Box sx={{ py: 2, padding: {xs: 3, sm: 4,  md: 4,} }}>
                    <Box>
                        <Typography variant="h2" sx={{ fontWeight: "bold" }}>
                        <span style={{ color: "#009bd6" }}>Supply</span>
                        </Typography>
                        <Divider />
                    </Box>
                    {supply?.map((supply) => (
                        <Grid container key={supply?.id} spacing={3}>
                        <Grid item md={6} xs={12}>
                            <Box sx={{ mt: 3 }}>
                            <img
                                className="imagee"
                                src={supply.img}
                                style={{
                                width: "100%",
                                height: 300,
                                borderRadius: "8px",
                                objectFit: "cover",
                                }}
                                alt="mission&vision"
                            />
                            </Box>
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <Box sx={{ mt: 6 }}>
                            <Typography
                                variant="h3"
                                sx={{
                                fontSize: "20px",
                                color:"white",
                                mt: 2,
                                mb: 1,
                                fontWeight: "bold",
                                }}
                            >
                                {supply.title}
                            </Typography>
                            {supply.points?.map((item, index) => (
                                <Stack
                                direction="row"
                                fontSize={15}
                                spacing={2}
                                color={"#e6e6e6"}
                                >
                                <Icon icon="material-symbols-light:check-box" />
                                <Typography key={index} sx={{ fontSize: "18px" }}>
                                    {item}
                                </Typography>
                                </Stack>
                            ))}
                            </Box>
                        </Grid>
                        </Grid>
                    ))}
                    </Box>
                </Container>
            </Box>
            <Footer/>
      </div>
    )
}

  const supply = [
    {
      id: 1,
      title: "ASH Handling Plant",
      img: "../img/SupplyImg/AHP.jpg",
      points: [
        "Bag Filter",
        "Clinker Grinder",
        "ACI Bends ",
        "ASH Vessels",
        "Dome Valves",
        "Double Disc Valves",
        "All Equipment & Spares",
      ],
    },
    {
      id: 2,
      title: "Main Plant (BMD)",
      img: "../img/SupplyImg/BMD.jpg",
      points: [
        "	Boiler Tubes",
        "	Coils",
        "	Valves ",
        "Gratings",
        "Shield Pipe & Equipment",
        "Coal",
        "All Equipment & Spares",
      ],
    },
    {
      id: 3,
      title: "ESP",
      img: "../img/SupplyImg/ESP.jpg",
      points: [
        "Collecting Electrodes",
        "	Hammer",
        "Expansion Joints. ",
        "Discharge Electrodes.",
        "GD Screen.",
        "Pin Wheel.",
        "Plain Bearing",
      ],
    },
    {
      id: 1,
      title: "Coal Handling Plant",
      img: "../img/SupplyImg/CHP.jpg",
      points: [
        "	Pulley",
        "Roller",
        "Roller Brackets",
        "Shafts",
        "Repairing Jobs",
        "Fabrication Works",
        "All Equipment & Spares",
      ],
    },
  ];
  